export function formatHoursMinutes(hours) {
  if (!hours) return "0h 0m";

  const totalMinutes = Math.round(hours * 60);

  const hrs = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;

  return `${hrs}h ${mins}m`;
}